"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACHIEVEMENT_LEVEL_SETTING = exports.AchievementLevelId = exports.AchievementStatus = exports.ACHIEVEMENT_SETTING = exports.AchievementType = void 0;
var AchievementType;
(function (AchievementType) {
    AchievementType["CompleteProfile"] = "CompleteProfile";
    AchievementType["ReferCreatorLv1"] = "ReferCreatorLv1";
    AchievementType["ReferCreatorLv2"] = "ReferCreatorLv2";
    AchievementType["ReferCreatorLv3"] = "ReferCreatorLv3";
    AchievementType["ReferCreatorLv4"] = "ReferCreatorLv4";
    AchievementType["ReferCreatorLv5"] = "ReferCreatorLv5";
    AchievementType["PublishPlanLv1"] = "PublishPlanLv1";
    AchievementType["PublishPlanLv2"] = "PublishPlanLv2";
    AchievementType["PublishPlanLv3"] = "PublishPlanLv3";
    AchievementType["PublishPlanLv4"] = "PublishPlanLv4";
    AchievementType["PublishPlanLv5"] = "PublishPlanLv5";
})(AchievementType = exports.AchievementType || (exports.AchievementType = {}));
exports.ACHIEVEMENT_SETTING = {
    [AchievementType.CompleteProfile]: {
        type: AchievementType.CompleteProfile,
        title: 'Complete profile information',
        points: 50,
    },
    [AchievementType.ReferCreatorLv1]: {
        type: AchievementType.ReferCreatorLv1,
        title: 'Refer 1 creator',
        points: 50,
        threshold: 1,
    },
    [AchievementType.ReferCreatorLv2]: {
        type: AchievementType.ReferCreatorLv2,
        title: 'Refer 5 creators',
        points: 200,
        threshold: 5,
    },
    [AchievementType.ReferCreatorLv3]: {
        type: AchievementType.ReferCreatorLv3,
        title: 'Refer 10 creators',
        points: 500,
        threshold: 10,
    },
    [AchievementType.ReferCreatorLv4]: {
        type: AchievementType.ReferCreatorLv4,
        title: 'Refer 20 creators',
        points: 1000,
        threshold: 20,
    },
    [AchievementType.ReferCreatorLv5]: {
        type: AchievementType.ReferCreatorLv5,
        title: 'Refer 50 creators',
        points: 2500,
        threshold: 50,
    },
    [AchievementType.PublishPlanLv1]: {
        type: AchievementType.PublishPlanLv1,
        title: 'Successfully published 1 plan',
        points: 50,
        threshold: 1,
    },
    [AchievementType.PublishPlanLv2]: {
        type: AchievementType.PublishPlanLv2,
        title: 'Successfully published 5 plans',
        points: 200,
        threshold: 5,
    },
    [AchievementType.PublishPlanLv3]: {
        type: AchievementType.PublishPlanLv3,
        title: 'Successfully published 10 plans',
        points: 500,
        threshold: 10,
    },
    [AchievementType.PublishPlanLv4]: {
        type: AchievementType.PublishPlanLv4,
        title: 'Successfully published 20 plans',
        points: 1000,
        threshold: 20,
    },
    [AchievementType.PublishPlanLv5]: {
        type: AchievementType.PublishPlanLv5,
        title: 'Successfully published 50 plans',
        points: 2500,
        threshold: 50,
    },
};
var AchievementStatus;
(function (AchievementStatus) {
    AchievementStatus["Collected"] = "collected";
    AchievementStatus["Locked"] = "locked";
    AchievementStatus["Unlocked"] = "unlocked";
})(AchievementStatus = exports.AchievementStatus || (exports.AchievementStatus = {}));
var AchievementLevelId;
(function (AchievementLevelId) {
    AchievementLevelId[AchievementLevelId["Explorer"] = 1] = "Explorer";
    AchievementLevelId[AchievementLevelId["Adventurer"] = 2] = "Adventurer";
    AchievementLevelId[AchievementLevelId["Nomad"] = 3] = "Nomad";
    AchievementLevelId[AchievementLevelId["Globetrotter"] = 4] = "Globetrotter";
    AchievementLevelId[AchievementLevelId["Voyager"] = 5] = "Voyager";
})(AchievementLevelId = exports.AchievementLevelId || (exports.AchievementLevelId = {}));
exports.ACHIEVEMENT_LEVEL_SETTING = {
    [AchievementLevelId.Explorer]: {
        id: AchievementLevelId.Explorer,
        title: 'Explorer',
        minPoints: 0,
    },
    [AchievementLevelId.Adventurer]: {
        id: AchievementLevelId.Adventurer,
        title: 'Adventurer',
        minPoints: 300,
    },
    [AchievementLevelId.Nomad]: {
        id: AchievementLevelId.Nomad,
        title: 'Nomad',
        minPoints: 600,
    },
    [AchievementLevelId.Globetrotter]: {
        id: AchievementLevelId.Globetrotter,
        title: 'Globetrotter',
        minPoints: 1000,
    },
    [AchievementLevelId.Voyager]: {
        id: AchievementLevelId.Voyager,
        title: 'Voyager',
        minPoints: 2000,
    },
};
